export const LOAD_SIMILAR_DATA = 'containers/SimilarPage/LOAD_SIMILAR_DATA';
export const LOAD_SIMILAR_DATA_SUCCESS = 'containers/SimilarPage/LOAD_SIMILAR_DATA_SUCCESS';
export const LOAD_SIMILAR_DATA_ERROR = 'containers/SimilarPage/LOAD_SIMILAR_DATA_ERROR';

export const FILTER_ORDER_BY = 'containers/SimilarPage/FILTER_ORDER_BY';
export const FILTER_PER_PAGE = 'containers/SimilarPage/FILTER_PER_PAGE';

export const CHANGE_PAGE = 'containers/SimilarPage/CHANGE_PAGE';
